import React from 'react';
import * as actions from "../../../store/actions";

import {
  Button,
  Dialog, DialogContent, DialogContentText, DialogTitle,
} from '@mui/material';
import { i18n } from '../../../translate/i18n';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom'

function BlockedTenantDialog(props) {
  const dispatch = useDispatch();
  const history = useHistory();

  const signOut = () => {
    dispatch(actions.logout())
    history.push(`/login`)
  }

  return (
    <Dialog
      fullWidth
      maxWidth='md'
      scroll='body'
      open={props.open}
      onClose={props.handleClose()}
    >
      <DialogTitle id="form-dialog-title">{i18n.t('blockedTenantDialog.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
        {i18n.t('blockedTenantDialog.text')}
        <div style={{ display: 'flex', justifyContent: 'center'}}><Button onClick={() => signOut()}>OK</Button></div>
        </DialogContentText>
      </DialogContent>

    </Dialog>
  )
}

export default BlockedTenantDialog;
